import type { addCollection } from '@iconify/vue'
import type { ChildAppConfig } from '@shared/app-config'
import wippyIcons from '@app/plugins/iconify/wippy.json'

export function addIcons(addCollectionFn: typeof addCollection, appConfig: ChildAppConfig) {
  // Deprecated: icons field (all go to 'custom' prefix)
  const legacyIcons = appConfig.theming?.global?.icons
  if (legacyIcons) {
    addCollectionFn({
      prefix: 'custom',
      icons: legacyIcons,
    })
  }

  // New: named icon sets (each key is a prefix)
  const iconSets = appConfig.theming?.global?.iconSets
  if (iconSets) {
    for (const [prefix, icons] of Object.entries(iconSets)) {
      if (prefix === 'custom' && legacyIcons) {
        // Merge with legacy icons (iconSets.custom wins)
        addCollectionFn({
          prefix: 'custom',
          icons: { ...legacyIcons, ...icons },
        })
      }
      else {
        addCollectionFn({
          prefix,
          icons,
        })
      }
    }
  }

  addCollectionFn(wippyIcons)
}
